import { BaseController } from '../../../../../common/base/controller';

import template from './conflictModal.html';

class StandingOrderConflictModalController extends BaseController {
  constructor(
    controllerService,
    userImportService,
    $document,
    notificationService,
    standingOrderConflictModalService,
  ) {
    'ngInject';
    super({
      controllerService,
      userImportService,
      $document,
      notificationService,
      standingOrderConflictModalService,
    });
  }

  get conflictType() {
    return this.resolve.conflictData.reason;
  }

  get conflictData() {
    return this.resolve.conflictData.conflict;
  }

  get isNextExecutionDayConflict() {
    return this.conflictType === 'NEXT_EXECUTION_DAY_CONFLICT';
  }

  get isCrossBorderConflict() {
    return this.conflictType === 'CROSS_BORDER_CONFLICT';
  }

  get isAlreadyExistsConflict() {
    return this.conflictType === 'ALREADY_EXISTS_CONFLICT';
  }

  close() {
    this.standingOrderConflictModalService.closeModal();
  }

  approve() {
    this.standingOrderConflictModalService.closeModal({
      conflictSolution: this.conflictSolution,
      approved: true,
      errorReason: this.conflictType,
    });
  }

  $onInit() {
    this.crossBorderConflictOptions = {
      validate: 'bic',
    };

    this.messages = {
      required: 'app.form.error.message.required',
      bic: 'app.form.error.message.bic',
    };

    this.nextExectionDayConflictOptions = {
      modelKey: 'key',
      orderKeys: false,
      searchEnabled: false,
      selectables: [
        {
          key: 'EXECUTION_DAY',
          value: `${this.$translate.instant(
            'standingOrdersConflict.modal.NEXT_EXECUTION_DAY_CONFLICT.EXECUTION_DAY',
          )} (${this.conflictData && this.conflictData.executionDay}.)`,
        },
        {
          key: 'NEXT_EXECUTION_DATE',
          value: `${this.$translate.instant(
            'standingOrdersConflict.modal.NEXT_EXECUTION_DAY_CONFLICT.EXECUTION_DATE',
          )} (${this.conflictData && this.conflictData.nextExecutionDay}.)`,
        },
      ],
    };
  }
}

export default {
  restrict: 'E',
  bindings: {
    resolve: '<',
  },
  template,
  controllerAs: 'vm',
  controller: StandingOrderConflictModalController,
};
